import { render, staticRenderFns } from "./PrevPurchaseShipmentModal.vue?vue&type=template&id=85061482&scoped=true"
import script from "./PrevPurchaseShipmentModal.vue?vue&type=script&lang=js"
export * from "./PrevPurchaseShipmentModal.vue?vue&type=script&lang=js"
import style0 from "./PrevPurchaseShipmentModal.vue?vue&type=style&index=0&id=85061482&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85061482",
  null
  
)

export default component.exports